quoteModule.directive('vehicleDefinition', function factory() {

	return {
		templateUrl: 'app/modules/quote/directives/vehicle-definition-directive.html',
		replace: true,
		transclude: false,
		restrict: 'E',
		controller: 'vehicleDefinitionController',
		link: function(scope, element, attrs, vehicleDefCtrl) {
     		 vehicleDefCtrl.init( element );
    	}
	};
});